import { render, staticRenderFns } from "./BookBorrow.vue?vue&type=template&id=ad2010e2&scoped=true&"
import script from "./BookBorrow.vue?vue&type=script&lang=js&"
export * from "./BookBorrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2010e2",
  null
  
)

export default component.exports